<app-menu-bar title="{{ title }}" *ngIf="azureAws.isLogged && isBrowserCompatible()"></app-menu-bar>
<div class="container-fluid px-3" *ngIf="isBrowserCompatible()">
  <router-outlet>
    <swl-feedback></swl-feedback>
    <app-confirmation-dialog></app-confirmation-dialog>
    <div *ngIf="globals.loading" class="k-i-loading"></div>
  </router-outlet>
</div>
<div class="container" *ngIf="!isBrowserCompatible()">
  <div class="row">
      <div class="col-md-12">
          <div class="errorTemplate">
              <h2 style="color:rgb(0,135,205);">
                  {{title}} is not supported in this browser</h2>
              <h2 style="color:rgb(0,135,205);">
                  Please open it using the Chrome instead</h2>
              <div class="errorMessage">
                  (Note: Raise a Service Request to get Chrome installed on your machine if you don't have it installed already)
              </div>
          </div>
      </div>
  </div>
</div>